<script>
// 新建服务报告
import DragUpload from "@/views/widgets/upload-files/drag-upload";
import {getCustomerContactList, getEngineer} from "@/helpers/common-service";
import CustomerSelect from "@/views/work-order/components/widgets/customer-select";
import {alertError, successMsg} from "@/helpers/swal";
import {createServiceReport, postCustomerContact} from "@/service";
import {useVuelidate} from "@vuelidate/core";
import {required, email} from "@vuelidate/validators";
import {SERVICE_REPORT_TYPE} from "@/config/common";
import _ from 'lodash'
import serviceCompanySelect from "@/views/work-order/components/widgets/service-company-select";
import {toUtcFormat, getCurrentTime} from "@/helpers/common";
import DeviceSelect from "@/views/widgets/device-select";
import i18n from "@/i18n";

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    title: {
      type: String,
      default: i18n.global.t('page.create')
    },
    woId: {
      type: [Number, String],
      default: 0
    },
    // 初始信息
    initInfo: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      showModal: false,
      form: {
        type: null,
        reporter_time:'',
      },
      files: [], // 文件对象列表
      SERVICE_REPORT_TYPE,
      datetimeConfig: {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        minuteIncrement: 1,
      },
      currentCustomer: {}, // 当前选择的客户对象
      contactsList: [], // 联系人列表
      engineerList: [], // 工程师列表
      // 泵头序列号、服务商、客户等关键信息是否可编辑，不可编辑时直接显示标题
      rootSnDisabled: false,
      customerTxt: null,
      serviceCompanyTxt: null,
    }
  },
  validations: {
    form: {
      type: { required },
      root_sn: { required },
      customer: { required },
      customer_contact: { required },
      customer_contact_number: { required },
      customer_email: { email },
      reporter: { required },
      service_company: { required },
      reporter_time: { required },
      attachment: { required },
    }
  },
  methods: {
    open() {
      this.formInit()
      this.showModal = true
    },
    formInit() {
      this.form = {
        type: null,
        root_sn:null,
        customer:null,
        customer_contact:null,
        customer_contact_number:null,
        customer_contact_name: null,
        customer_email:null,
        reporter:null,
        reporter_time: getCurrentTime('YYYY-MM-DD HH:mm'),
        service_company: null,
        attachment:[],
        work_order: null
      }
      this.files = []
      this.rootSnDisabled = false
      // 如果有初始信息，用初始信息填充泵头序列号、客户、联系人、联系电话、联系邮箱、服务商、工程师
      if (this.initInfo && Object.keys(this.initInfo).length) {
        this.form.root_sn = this.initInfo.device_root_sn
        this.form.customer = this.initInfo.customer
        this.form.service_company = this.initInfo.service_company
        this.form.reporter = this.initInfo.main_engineer
        this.rootSnDisabled = true
        this.customerTxt = this.initInfo.customer_txt
        this.serviceCompanyTxt = this.initInfo.service_company_txt
        this.$nextTick(() => {
          if (this.form.service_company) {
            this.serviceCompanyChange(this.form.service_company)
          }
          if (this.form.customer) {
            this.setCurrentCustomer({id: this.form.customer})
          }
        })
      } else {
        // 获取当前登录的用户信息
        const user = JSON.parse(localStorage.getItem('user'))
        const company_id = _.get(user, 'org.id')
        this.$nextTick(() => {
          // 如果user_type是service_company，用user.org.id 填充服务商
          if (user.user_type == 'service_company' && company_id) {
            this.form.service_company = company_id
            this.serviceCompanyChange(company_id)
          }
          // 清空设备序列号选择
          this.$refs.deviceSelect.clearCurrentSelectSn()
        })
      }
    },
    // 泵头序列号变化
    deviceChange(val) {
      // console.log('泵头序列号变化', val)
      this.form.root_sn = val.root_sn
      if (val.customer_id) {
        this.setCurrentCustomer({id: val.customer_id})
      }
    },
    // 附件选择
    filesUpload(ids) {
      this.form.attachment = ids
    },
    // 选择客户后
    setCurrentCustomer(value) {
      this.currentCustomer = value
      if (this.currentCustomer) {
        this.form.customer = this.currentCustomer.id
        // 清空联系人、电话、邮箱
        this.form.customer_contact = null
        this.form.customer_contact_number = null
        this.form.customer_contact_name = null
        this.form.customer_email = null
        // 获取该客户下的联系人列表
        getCustomerContactList(this.currentCustomer.id).then(res => {
          this.contactsList = res
          if (this.initInfo.customer_contact) {
            this.form.customer_contact = this.initInfo.customer_contact
            this.setCurrentContact(this.initInfo.customer_contact)
          }
        })
      }
    },
    // 选择联系人后，填充联系电话和电子邮箱
    setCurrentContact(value) {
      if (typeof value == 'number') {
        const currentContact = _.find(this.contactsList, ['id', value])
        if (currentContact) {
          this.form.customer_contact_number = currentContact.tel
          this.form.customer_contact_name = currentContact.name
          this.form.customer_email = currentContact.email
        }
      }
    },
    // 选择服务商后，获取服务商下的工程师
    serviceCompanyChange(value) {
      this.form.service_company = value
      this.form.reporter = null
      getEngineer(value).then(res => {
        this.engineerList = res
        // 如果只有一个工程师，则默认选中
        if (res.length == 1) {
          this.form.reporter = res[0].id
        }
      }).catch(err => {
        console.log(err)
      })
    },
    async save() {
      this.v$.form.$touch()
      const result = await this.v$.$validate()
      if (this.v$.form.customer_email.$errors.length) {
        alertError(this.$t('base.prompt'), this.$t('page.wrongEmailFormat'))
        return
      }
      if (!result || !this.form.customer || !this.form.type || !this.form.attachment.length) {
        alertError(this.$t('base.prompt'), this.$t('page.pleaseCompleteTheRequiredInformation'))
        return
      }
      // 如果联系人列表中没有，则新建联系人，再保存报告
      if (!_.find(this.contactsList, ['id', this.form.customer_contact])) {
        const contactData = {
          customer: this.form.customer,
          name: this.form.customer_contact,
          tel: this.form.customer_contact_number,
          email: this.form.customer_email,
        }
        postCustomerContact(contactData).then(res => {
          this.form.customer_contact = res.payload.id
          this.form.customer_contact_name = res.payload.name
          this.saveReport()
        }).catch(err => {
          console.log(err)
          alertError(this.$t('base.prompt'), this.$t('page.errorOnCreatingCustomerContact'))
        })
      } else {
        // 直接保存报告
        this.saveReport()
      }
    },
    // 保存报告
    saveReport() {
      if (this.woId) {
        this.form['work_order'] = this.woId
      }
      // 报告时间转成utc时间
      this.form.reporter_time = toUtcFormat(this.form.reporter_time)
      // 联系人传姓名过去
      // this.form.customer_contact = this.form.customer_contact_name
      createServiceReport(this.form).then(res => {
        if (![200, 201].includes(res.meta.code)) {
          alertError(this.$t('base.prompt'), res.meta.message)
          return
        }
        successMsg(this.$t('page.serviceReportCreatedSuccessfully'))
        this.showModal = false
        this.$emit('refresh')
      }).catch(err => {
        alertError(this.$t('base.prompt'), this.$t('base.an-error-occurred'))
        console.log(err)
      })
    },
  },
  components: {
    DragUpload,
    CustomerSelect,
    serviceCompanySelect,
    DeviceSelect,
  }
}
</script>
<template>
  <b-modal
      v-model="showModal"
      hide-footer
      :title="title"
      class="v-modal-custom"
      body-class="p-0"
      scrollable
      centered
      size="lg"
  >
    <div class="modal-body border-top" style="max-height: 60vh;">
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.reportType') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <Multiselect
            class="form-control"
            :class="v$.form.type.$errors.length ? 'is-invalid' : ''"
            :can-clear="false"
            :can-deselect="false"
            v-model="form.type"
            :close-on-select="true"
            :searchable="true"
            :create-option="false"
            :placeholder="$t('page.pleaseSelectType')"
            :options="SERVICE_REPORT_TYPE"
        />
      </div>
      <div class="mb-3 d-flex justify-content-between" v-if="!rootSnDisabled">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.pump_head_serial_number') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <DeviceSelect
            ref="deviceSelect"
            :selected-device-root-sn="form.root_sn"
            :is-search-call-api="true"
            :is-invalid="!!v$.form.root_sn.$errors.length"
            @changed="deviceChange"
        />
      </div>
      <div class="mb-3 d-flex justify-content-between" v-if="!rootSnDisabled">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.customer') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <customer-select :is-invalid="!!v$.form.customer.$errors.length" :selected-customer-id="form.customer" :can-clear="false" :can-deselect="false" @changed="setCurrentCustomer" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.contact') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <Multiselect
            :class="v$.form.customer_contact.$errors.length ? 'is-invalid' : ''"
            class="form-control"
            :value="form.customer_contact"
            v-model="form.customer_contact"
            :placeholder="$t('page.contact')"
            value-prop="id"
            label="name"
            @change="setCurrentContact"
            :close-on-select="true"
            :searchable="true"
            :create-option="true"
            :options="contactsList"
        />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.contact_number') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <input type="text" class="form-control" :class="v$.form.customer_contact_number.$errors.length ? 'is-invalid' : ''" :placeholder="$t('page.contact_number')" v-model="form.customer_contact_number"/>
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.email') }}</label>
        <input type="text" class="form-control" :placeholder="$t('page.email')" v-model="form.customer_email"/>
      </div>
      <div class="mb-3 d-flex justify-content-between" v-if="!rootSnDisabled">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.service-company') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <service-company-select :is-invalid="!!v$.form.service_company.$errors.length" :selected-service-company="form.service_company" @changed="serviceCompanyChange" />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.engineer') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <Multiselect
            :class="v$.form.reporter.$errors.length ? 'is-invalid' : ''"
            class="form-control"
            :value="form.reporter"
            v-model="form.reporter"
            :placeholder="$t('page.engineer')"
            value-prop="id"
            label="name"
            :close-on-select="true"
            :searchable="true"
            :create-option="false"
            :options="engineerList"
        />
      </div>
      <div class="mb-3 d-flex justify-content-between">
        <label class="form-label field-title" for="meta-keywords-input">{{ $t('page.fillingTime') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <flat-pickr v-model="form.reporter_time" :config="datetimeConfig" :placeholder="$t('base.select-time')"
                    class="form-control" :class="v$.form.reporter_time.$errors.length ? 'is-invalid' : ''"></flat-pickr>
      </div>
      <div class="mb-3">
        <label class="form-label" for="meta-keywords-input">{{ $t('page.reportFile') }}<span class="text-danger">（{{ $t('base.required') }}）</span></label>
        <DragUpload
            input-file-id="filesUpload"
            title=""
            :value="files"
            filename-prefix="report"
            @changed="filesUpload"
        />
      </div>
    </div>

    <div class="modal-footer v-modal-footer" style="padding-right: 20px;padding-bottom: 20px;">
      <b-button type="button" variant="light" @click="showModal = false">{{ $t('base.cancel') }}</b-button>
      <b-button type="button" variant="primary" @click="save">{{ $t('base.done') }}</b-button>
    </div>
  </b-modal>
</template>
<style scoped>
.field-title {
  width: 300px;
}
</style>
